import React, { useEffect, useRef } from 'react';
export function Hero() {
  const sectionRef = useRef<HTMLElement>(null);
  const imageRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current && imageRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          imageRef.current.style.transform = `translateY(${rect.top * 0.25}px)`;
        }
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section ref={sectionRef} className="relative h-screen overflow-hidden" data-id="element-108">
      <div ref={imageRef} className="absolute -inset-y-[20%] inset-x-0 transition-transform duration-100 will-change-transform" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-109" />
      <div className="absolute inset-0 bg-gradient-to-t from-espresso/30 to-transparent" data-id="element-110" />

      <div className="relative h-full max-w-7xl mx-auto px-6 flex flex-col justify-end pb-16 lg:pb-24" data-id="element-111">
        <h1 className="font-serif font-light text-4xl md:text-6xl lg:text-7xl text-cream mb-4 leading-tight" data-id="element-112">
          Move with intention.
        </h1>
        <p className="text-cream text-lg md:text-xl mb-8 max-w-xl" data-id="element-113">
          Elevated essentials for Pilates, yoga, and the in-between.
        </p>
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-114">
          <a href="#" className="bg-espresso text-cream px-8 py-4 rounded-full uppercase tracking-widest text-sm hover:bg-rust transition-colors text-center min-h-[48px] flex items-center justify-center" data-id="element-115">
            SHOP NEW IN
          </a>
          <a href="#" className="border-2 border-cream text-cream px-8 py-4 rounded-full uppercase tracking-widest text-sm hover:bg-cream hover:text-espresso transition-colors text-center min-h-[48px] flex items-center justify-center" data-id="element-116">
            SHOP BESTSELLERS
          </a>
        </div>
      </div>
    </section>;
}